module.exports = __webpack_public_path__ + "static/JoshuaA-c912a3c674d2e2437e78db6b924ccd48.gif";